import { AuditMetadata } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { UnnamedFunnel } from '@fullstory/proto/fs/services/dx-objects';
import { int64, timestamp } from '@fullstory/proto/google/protobuf';
import { AppState, RequestState } from '@fullstory/redux';
import { DeepPartial } from '@fullstory/typeutils';
import { DEFAULT_FUNNEL_NAME, mockFunnelDetail, mockUnnamedFunnel } from './utils';

const auditMetadata: Partial<AuditMetadata> = {
  lastUpdated: '2020-09-20T12:00:50.255Z' as timestamp,
  lastUpdatedBy: 'paul@fullstory.com',
  created: '2020-09-20T12:00:50.255Z' as timestamp,
  createdBy: 'paul@fullstory.com',
  archived: false,
  version: int64.fromNumber(1600603250255),
};

// TODO(kmorgannn): Update this to optionally take params then replace this function in
// legacy-app/src/ui/impacts/__tests__/utils/mock-redux-state.ts
export const makeFunnels = (): DeepPartial<AppState['funnels']> => ({
  funnels: {
    test: mockFunnelDetail({ name: DEFAULT_FUNNEL_NAME, metadata: auditMetadata }),
  },
});

const mockUnnamedFunnelState = (): DeepPartial<
  RequestState<{ [hash: string]: UnnamedFunnel }>
> => ({
  lastRequested: 0,
  lastResponded: 0,
  loading: false,
  error: false,
  data: {
    unnamedHash: mockUnnamedFunnel(),
    unnamedDisabledEventsHash: mockUnnamedFunnel('Disabled Events Funnel', [1]),
  },
});

export const mockInitialSavedFunnelsState = (
  name: string = DEFAULT_FUNNEL_NAME,
): DeepPartial<AppState> => ({
  funnels: {
    funnels: {
      test: mockFunnelDetail({ name }),
    },
    unnamedFunnels: mockUnnamedFunnelState(),
  },
});
